import { render, staticRenderFns } from "./LayoutSubNav.vue?vue&type=template&id=3b44f850&scoped=true"
import script from "./LayoutSubNav.vue?vue&type=script&lang=js"
export * from "./LayoutSubNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutSubNav.vue?vue&type=style&index=0&id=3b44f850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44f850",
  null
  
)

export default component.exports